export default "__VITE_ASSET__BW19qk6I__"